import { useTranslations } from 'next-intl';

const MAX_ITEMS = 8;
const INIT_OPTIONS = Array.from({ length: MAX_ITEMS }, (v, i) => i + 1);

export function useProductQuantityOptions(maxQuantity = 1) {
  const t = useTranslations();

  const optionsSize = Math.min(8, maxQuantity);
  const options = INIT_OPTIONS.map((option) => ({
    value: String(option),
    label: t('productBox.selectQuantity', { quantity: option }),
  })).slice(0, optionsSize);

  return {
    options,
  };
}
